import { render, staticRenderFns } from "./Agendas.vue?vue&type=template&id=3530163e"
import script from "./Agendas.vue?vue&type=script&lang=js"
export * from "./Agendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports